export const BASE_PATH = "/";
export const NOT_FOUND_PATH = "not-found";
export const SIGN_IN_PATH = "signin";
export const INVOICE_PATH = "invoice";
export const PAYMENT_PATH = "payment";
export const PAYMENT_SUCCESSFUL_PATH = "success";
export const PAYMENT_ERROR_PATH = "fail";
export const PAYMENT_CANCEL_PATH = "cancel";
